import { debounce } from "lodash";
import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { semvApi } from "../../../../../../shared/services/axios/apis.service";
import { Table } from "../../../../../../components/page-releated/grp-standard-screen/table";
import { secretaryListtableColumns } from "./columns";
import { SemvInput } from "../../../../../../components/ui/input";
import { Secretary } from "../types/types";
import {
    UpsertSecretaryModal,
    UpsertSecretaryModalHandles,
} from "../upsert/upsert";

export const ListSecretary = () => {
    const upsertRef = useRef<UpsertSecretaryModalHandles>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const debounceRef = useRef(
        debounce((searchterm: string) => {
            const draft = new URLSearchParams(searchParams);
            draft.set("name", searchterm);
            setSearchParams(draft);
        }, 300)
    );

    const { data } = useQuery({
        queryKey: ["gov-plan-secretary", searchParams.toString()],
        queryFn: async () => {
            const response = await semvApi.get<{
                secretary: Secretary[];
            }>(`/government-plan/secretary?${searchParams.toString()}`);

            return response.data;
        },
        initialData: { secretary: [] },
    });

    return (
        <>
            <div className="max-w-60">
                <SemvInput
                    name="searchTerm"
                    placeholder="Digite o nome"
                    defaultValue={searchParams.get("name") || ""}
                    onChange={(e) => {
                        debounceRef.current(e.target.value);
                    }}
                />
            </div>
            <Table
                dataSource={data.secretary}
                columns={secretaryListtableColumns((sec) =>
                    upsertRef.current?.open(sec)
                )}
            />
            <UpsertSecretaryModal ref={upsertRef} />
        </>
    );
};
